 
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-forgot-password',
  imports: [ReactiveFormsModule, CommonModule, HeaderComponent],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../login/login.component.scss'] // Reusing login styles
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup;
  isLoading = false;
  message = '';

  constructor(private fb: FormBuilder, private authService: AuthService) {
    
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  async onSubmit() {
    if (this.forgotPasswordForm.invalid) return;

    this.isLoading = true;

    try {
        const redirectTo = window.location.origin + '/reset-password';
        const data = await this.authService.sendPasswordReset(this.forgotPasswordForm.value.email, redirectTo)
        this.message = 'Check your email for the reset link!';
    } catch (error: any) {
        console.error('Error sending password reset email:', error)
        this.message = `Error: ${error.message}`;
    } finally {
        this.isLoading = false;
    }
  }
}
